import type { AxiosResponse } from 'axios';
import { http } from '@/services/http.service';

/** The relational settings row of a brand, as published by the public endpoint. */
export interface TenantSettings {
  logo_url: string | null;
  favicon_url: string | null;
  primary_color: string | null;
  secondary_color: string | null;
  navbar_color: string | null;
  currency: string;
  locale: string;
  timezone: string;
  bookings_enabled: boolean;
  online_payment_enabled: boolean;
  telegram_enabled: boolean;
  seo?: {
    ai_prefetch?: string | null;
  };
}

export interface TenantSeo {
  title: string | null;
  description: string | null;
  keywords: string | null;
  canonical_url: string | null;
  og_title: string | null;
  og_description: string | null;
  og_image_url: string | null;
  og_type: string;
  twitter_card: string;
  robots: string;
}

/**
 * The brand serving this request. Mirrors the payload of
 * `Api::V1::CurrentTenantController#payload`: `name` is null on the platform apex,
 * which is why `isPlatform` exists as a separate flag rather than being inferred.
 */
export interface CurrentTenant {
  isPlatform: boolean;
  domain: string;
  name: string | null;
  settings: TenantSettings | null;
  seo: TenantSeo | null;
}

/**
 * Public, unauthenticated, read-only. The route is deliberately not under
 * `resources :tenants`, which is platform-admin-only.
 */
export const fetchCurrentTenant = (): Promise<AxiosResponse<CurrentTenant>> => {
  return http.get('api/v1/current_tenant');
};
